import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import gs from '../../global.css';
import { auth } from '../../actions';
import AuthenticationForm from './AuthenticationForm';
import CodeForm from './CodeForm';
import PasswordForm from './PasswordForm';
import QRView from './QRView';
import PasswordRecovery from './PasswordRecovery';
import WalletPasswordForm from './WalletPasswordForm';
const LoginScreen = (props) => {
    const history = useHistory();
    const [form, setForm] = useState('authentication');
    useEffect(() => {
        if (/Mobi|Android/i.test(navigator.userAgent)) {
            history.push('/');
        }
    }, []);
    useEffect(() => {
        if (props.isAuthenticated && props.user) {
            window.location.href = '/vault/files';
        }
        const unlisten = history.listen((location, action) => {
            if (action === 'POP' && form === 'qr') {
                window.history.pushState({}, '', '/portal-login');
                setForm('authentication');
            }
            if (action === 'POP' && form === 'passwordRecovery') {
                window.history.pushState({}, '', '/portal-login');
                setTimeout(() => setForm('password'), 0);
            }
        });
        return () => {
            unlisten();
        };
    }, [form]);
    return (React.createElement("div", { className: gs.main },
        React.createElement("div", { className: `${gs.screenContainer} ${gs.centerScreen}` },
            React.createElement("div", { className: gs.box },
                form === 'passwordRecovery' ? (React.createElement("h1", null, "Password Recovery")) : form === 'qr' ? (React.createElement("h1", null,
                    "Download ",
                    React.createElement("span", { style: { fontFamily: 'Sirin Stencil' } }, "Sticknet"),
                    " app")) : (React.createElement("h1", null, "Login to access your Vault")),
                form === 'authentication' ? (React.createElement(AuthenticationForm, { setForm: setForm })) : form === 'code' ? (React.createElement(CodeForm, { setForm: setForm })) : form === 'password' ? (React.createElement(PasswordForm, { setForm: setForm })) : form === 'qr' ? (React.createElement(QRView, null)) : form === 'passwordRecovery' ? (React.createElement(PasswordRecovery, null)) : form === 'walletPassword' ? (React.createElement(WalletPasswordForm, null)) : null))));
};
const mapStateToProps = (state) => ({
    country: state.appTemp.country,
    phone: state.app.phone,
    isAuthenticated: state.auth.isAuthenticated,
    user: state.auth.user,
});
const connector = connect(mapStateToProps, { ...auth });
export default connector(LoginScreen);
